import { api, helpers, ts } from '_core';

import { generateSignalsFromVisual } from './definition';

type SignalSetApiResponse = {
  data: ts.types.signalSet.SignalSet;
};

export const createSignalSet = async (
  newData: ts.types.signalSet.SignalSetDraft,
  callback: (_data: ts.types.signalSet.SignalSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: SignalSetApiResponse = await api.signal_sets.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating signal set - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateSignalSet = async (
  id: number,
  newData: ts.types.signalSet.SignalSetDraft,
  callback: (_data: ts.types.signalSet.SignalSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: SignalSetApiResponse = await api.signal_sets.update(id, { ...newData });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating signal set - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  signalSet: ts.types.signalSet.SignalSet,
  definition: ts.types.signalSet.DefinitionDraft,
  isValid: boolean,
  callback: (_data: ts.types.signalSet.SignalSet, _signals: ts.types.signalSet.SignalMetadata[]) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const signals = generateSignalsFromVisual(definition as ts.types.signalSet.Definition);

    const resp = await api.signal_sets.update(
      signalSet.id,
      {
        definition: {
          signals,
        },
        ui_metadata: {
          ...signalSet.ui_metadata,
          visual_def: definition,
        },
        is_valid: isValid,
        skip_signature_check: !isValid,
      },
      true
    );

    callback(resp.data, signals);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};
